import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*#__PURE__*/_defineComponent({
  __name: 'BaseSegment',
  props: {
  label: {
    type: String,
    required: true
  },
  selected: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(["focus:outline-none min-h-10 leading-tight rounded-md py-3 flex flex-row m-0 items-center px-4 border-gray-200 text-center focus:outline text-gray-500 text-sm font-medium border-gray-300 select-none cursor-pointer", [__props.selected ? 'bg-white text-gray-900 shadow border' : 'text-gray-500']])
  }, _toDisplayString(__props.label), 3))
}
}

})